import moment from 'moment-timezone';

import { ReportDateFilter, ReportParamFilters } from '@core/reports-types';

export const formatTrackedDateSimple = (dateFilter: ReportDateFilter) =>
  dateFilter.dateRange === 'range'
    ? moment(dateFilter.dateEnd).diff(moment(dateFilter.dateStart), 'days')
    : dateFilter.dateRange;

export const formatTrackedFilters = (
  dateFilter: ReportDateFilter,
  paramFilter: ReportParamFilters,
): { dateFilter: string; paramFilter: string[]; customDateRangeDays: number | false } => ({
  customDateRangeDays:
    dateFilter.dateRange === 'range'
      ? moment(dateFilter.dateEnd).diff(moment(dateFilter.dateStart), 'days')
      : false,
  dateFilter: <string>dateFilter.dateRange,
  paramFilter: paramFilter.map(a => a.group).filter((v, i, a) => a.indexOf(v) === i),
});
